import { Box, Stack } from "@mui/material";
import { useTheme, useApp } from "contexts";
import { Custom } from "components";
import { Fields } from "./Fields";
import { useResetPassword } from "./useResetPassword";

type Props = {
  id: string;
};

export const Form = (props: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();
  const {
    password,
    isPasswordValid,
    handlePasswordChange,
    handlePasswordValid,
    handleSubmit,
  } = useResetPassword(props.id);

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Stack spacing={theme.spacing.md}>
        {/* <Custom.Typography size={theme.font.md} weight={theme.font.bold}>
          {t.component.reset_password.title}
        </Custom.Typography> */}

        <Fields
          onPasswordChange={handlePasswordChange}
          onPasswordValid={handlePasswordValid}
        />

        <Custom.Button
          submit
          fullWidth
          trailing="right"
          variant="contained"
          disabled={!isPasswordValid}
          sx={{ mt: theme.spacing.md }}
        >
          {t.action.submit}
        </Custom.Button>
      </Stack>
    </Box>
  );
};
